import React from 'react'
import { isArray, toString, isString, isPlainObject } from 'lodash-es'
import { IconMaps } from '@ow/icons'

const IconedTextRender = function ({ stext, opts }) {
  const { text, color, icon } = stext
  const { maxlen } = opts
  const finalText =
    opts.type === 'text' ? text && text.substr(0, maxlen || 200) : text

  return (
    <div
      className="flex items-center gap-1"
      style={{
        color,
        fontWeight: opts.bind_primary ? 'bold' : '400',
      }}
    >
      <IconMaps type={icon} width={13} height={13} fill="currentColor" />
      {finalText}
    </div>
  )
}

const PlainTextRender = function ({ stext, opts }) {
  const isDom = React.isValidElement(stext)
  const { maxlen } = opts
  const finalText =
    opts.type === 'text' && !isDom
      ? stext.text && stext.text.slice(0, maxlen || 200)
      : stext.text

  return stext.onClick ? (
    <div
      className="cursor-pointer w-full"
      onClick={stext.onClick}
      title={stext.text}
    >
      {isDom ? stext : finalText}
    </div>
  ) : (
    <span
      title={stext.text}
      style={{
        fontWeight: opts.bind_primary ? 'bold' : '400',
      }}
    >
      {isDom ? stext : finalText}
    </span>
  )
}

const TextRender = function ({ value, onClick, opts }) {
  const stext = {
    onClick,
  }

  if (isString(value)) {
    stext.text = value
  } else if (isPlainObject(value)) {
    Object.assign(stext, value)
  } else {
    stext.text = toString(value)
  }

  return stext.icon ? (
    <IconedTextRender stext={stext} opts={opts} />
  ) : (
    <PlainTextRender stext={stext} opts={opts} />
  )
}

const Text = function ({ value, onClick, defs: opts = {} }) {
  if (isArray(value)) {
    return (
      <>
        {value.map((item) => {
          return (
            <div
              key={item}
              style={{
                background: 'var(--ow-color-neutral-100)',
                borderRadius: '4px',
                padding: '2px 8px',
                fontWeight: opts && opts.bind_primary ? 'bold' : '400',
              }}
            >
              <TextRender value={item} onClick={onClick} opts={opts} />
            </div>
          )
        })}
      </>
    )
  }

  return <TextRender value={value} onClick={onClick} opts={opts} />
}

export default Text
